import React, { useEffect, useState, useRef } from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import Teacher from './pages/Teacher';
import Myapp from './pages/Myapp';
import Pwa from './pages/Pwa';
import Contact from './pages/Contact';
import './App.scss';

const App: React.FC = () => {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const navRef = useRef<HTMLUListElement | null>(null);

  const getMenuIcon = (label: string) => {
    // Return a small representative SVG icon as a data URL for each menu label
    const icons: Record<string, string> = {
      Teacher: `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='48' height='48'><path fill='%23ffffff' d='M20 2H4c-1.1 0-2 .9-2 2v14l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z'/></svg>`,
      Myapp: `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='48' height='48'><path fill='%23ffffff' d='M3 13h4v8H3zM10 7h4v14h-4zM17 3h4v18h-4z'/></svg>`,
      Pwa: `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='48' height='48'><path fill='%23ffffff' d='M12 3v10.55A4 4 0 1 0 14 17V7h4V3h-6z'/></svg>`,
      Contact: `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='48' height='48'><path fill='%23ffffff' d='M6 2h12v16l-6-2-6 2V2z'/></svg>`
    };

    const svg = icons[label] || `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' width='48' height='48'><rect width='100%' height='100%' rx='6' fill='%23222'/><text x='50%' y='50%' font-size='10' fill='%23fff' text-anchor='middle' dominant-baseline='middle'>${label.slice(0, 2)}</text></svg>`;
    return 'data:image/svg+xml;utf8,' + encodeURIComponent(svg);
  };

  useEffect(() => {
    if (!isNavVisible) return;
    const handleClickOutside = (e: MouseEvent) => {
      if (navRef.current && !navRef.current.contains(e.target as Node)) {
        setIsNavVisible(false);
      }
    };
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setIsNavVisible(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleKey);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleKey);
    };
  }, [isNavVisible]);

  const toggleNav = () => {
    setIsNavVisible(!isNavVisible);
  };

  return (
    <div className="app-container">
      <div className="background-image"></div>
      <nav className="main-nav">
        <div className="hamburger-menu" onClick={toggleNav}>
          {/* Hamburger icon */}
          <div></div>
          <div></div>
          <div></div>
        </div>
        {isNavVisible && (
          <ul className="page-list" ref={navRef}>
            <li className="menu-item">
              <NavLink className={({ isActive }) => `menu-link ${isActive ? 'selected' : ''}`} to="/teacher" onClick={() => setIsNavVisible(false)}>
                <div className="menu-thumb"><img src={getMenuIcon('Teacher')} alt="Teacher" /></div>
                <span className="menu-label">Teacher</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink className={({ isActive }) => `menu-link ${isActive ? 'selected' : ''}`} to="/myapp" onClick={() => setIsNavVisible(false)}>
                <div className="menu-thumb"><img src={getMenuIcon('Myapp')} alt="Myapp" /></div>
                <span className="menu-label">My App</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink className={({ isActive }) => `menu-link ${isActive ? 'selected' : ''}`} to="/pwa" onClick={() => setIsNavVisible(false)}>
                <div className="menu-thumb"><img src={getMenuIcon('Pwa')} alt="Pwa" /></div>
                <span className="menu-label">AI PWA</span>
              </NavLink>
            </li>
            <li className="menu-item">
              <NavLink className={({ isActive }) => `menu-link ${isActive ? 'selected' : ''}`} to="/contact" onClick={() => setIsNavVisible(false)}>
                <div className="menu-thumb"><img src={getMenuIcon('Contact')} alt="Contact" /></div>
                <span className="menu-label">Contact</span>
              </NavLink>
            </li>
          </ul>
        )}
        <div className="speed-buttons">
        </div>
      </nav>
      <main className="content">
        <Routes>
          <Route path="/" element={<Teacher />} />
          <Route path="/teacher" element={<Teacher />} />
          <Route path="/myapp" element={<Myapp />} />
          <Route path="/pwa" element={<Pwa />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>
    </div>
  );
};

export default App;
